module.exports = __webpack_public_path__ + "img/asterisk.35fec3da.svg";